import type { CSSProperties } from "react";

/**
 * Yapısal eleman (çizgi / grup kartı) stili — paylaşılan tip + varsayılanlar.
 * divider: yatay/dikey çizgi (kalınlık, renk, padding). card: bölge arka-plan kutusu (padding, arka plan, kenar).
 */
export type FieldStyle = {
  orientation?: "h" | "v"; // divider yönü
  thickness?: number;      // divider kalınlık (px)
  color?: string;          // divider çizgi / card kenar rengi (HEX)
  padding?: number;        // divider/card iç boşluk (px)
  bg?: string | null;      // card arka plan (HEX; null = şeffaf)
};

export const DEFAULT_DIVIDER_STYLE: FieldStyle = { orientation: "h", thickness: 2, color: "#cbd5e1", padding: 8 };
export const DEFAULT_CARD_STYLE: FieldStyle = { padding: 12, color: "#e2e8f0", bg: "#f8fafc" };

/** Divider (çizgi) CSS'i — konteyner (padding) + çizgi kutusu. */
export function dividerStyles(s: FieldStyle | null | undefined): { wrap: CSSProperties; line: CSSProperties } {
  const st = s ?? DEFAULT_DIVIDER_STYLE;
  const vertical = st.orientation === "v";
  const t = Math.max(1, st.thickness ?? 2);
  const pad = Math.max(0, st.padding ?? 8);
  const color = st.color ?? "#cbd5e1";
  return {
    wrap: { display: "flex", alignItems: "center", justifyContent: "center", width: "100%", height: "100%", padding: vertical ? `${pad}px 0` : `${pad}px 0`, minHeight: vertical ? undefined : t + pad * 2 },
    line: vertical
      ? { width: t, minHeight: 24, alignSelf: "stretch", background: color, borderRadius: t }
      : { height: t, width: "100%", background: color, borderRadius: t },
  };
}

/** Card (grup kutusu) CSS'i. */
export function cardStyles(s: FieldStyle | null | undefined): CSSProperties {
  const st = s ?? DEFAULT_CARD_STYLE;
  return {
    padding: Math.max(0, st.padding ?? 12),
    background: st.bg ?? "transparent",
    border: `1px solid ${st.color ?? "#e2e8f0"}`,
    borderRadius: 8,
    height: "100%",
    boxSizing: "border-box",
  };
}
